/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.OutOfOfficeHoursRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './OutOfOfficeHoursRpc';
import * as Queries from './OutOfOfficeHoursRpc.dfc.new';
import type { AdditionalContextArgs } from './OutOfOfficeHoursRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseFetchOutOfOfficeStatusesQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.FetchOutOfOfficeStatusesResponseType>,
    References.FetchOutOfOfficeStatusesRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'fetchOutOfOfficeStatuses',
            References.FetchOutOfOfficeStatusesResponseType
          >
        : References.FetchOutOfOfficeStatusesResponseType)
    | undefined;
};

export function useFetchOutOfOfficeStatusesQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.FetchOutOfOfficeStatusesResponseType>,
    References.FetchOutOfOfficeStatusesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchOutOfOfficeStatusesQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.FETCH_OUT_OF_OFFICE_STATUSES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchOutOfOfficeStatuses: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchOutOfOfficeStatusesQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchOutOfOfficeStatusesQueryReturn<T>;
}

type UseFetchOutOfOfficeStatusesLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.FetchOutOfOfficeStatusesResponseType>,
    References.FetchOutOfOfficeStatusesRequestType,
    T extends true
      ? Record<
          'fetchOutOfOfficeStatuses',
          References.FetchOutOfOfficeStatusesResponseType
        >
      : References.FetchOutOfOfficeStatusesResponseType
  >;

export function useFetchOutOfOfficeStatusesLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.FetchOutOfOfficeStatusesResponseType>,
    References.FetchOutOfOfficeStatusesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchOutOfOfficeStatusesLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.FETCH_OUT_OF_OFFICE_STATUSES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchOutOfOfficeStatuses: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseFetchOutOfOfficeStatusesLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseFetchOutOfOfficeStatusesLazyQueryReturn<T>;
}

type UseFetchOutOfOfficeStatusesSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.FetchOutOfOfficeStatusesResponseType>,
    References.FetchOutOfOfficeStatusesRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'fetchOutOfOfficeStatuses',
        References.FetchOutOfOfficeStatusesResponseType
      >
    : References.FetchOutOfOfficeStatusesResponseType;
};

export function useFetchOutOfOfficeStatusesSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.FetchOutOfOfficeStatusesResponseType>,
    References.FetchOutOfOfficeStatusesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchOutOfOfficeStatusesSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.FETCH_OUT_OF_OFFICE_STATUSES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            fetchOutOfOfficeStatuses: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchOutOfOfficeStatusesSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchOutOfOfficeStatusesSuspenseQueryReturn<T>;
}
